import { render } from "./HeroInternal.vue?vue&type=template&id=1068fa86"
import script from "./HeroInternal.vue?vue&type=script&lang=js"
export * from "./HeroInternal.vue?vue&type=script&lang=js"

import "./HeroInternal.vue?vue&type=style&index=0&id=1068fa86&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__